import React from 'react'
import { Button, Card, Form, Input, Modal, Space, Table, Tag, message } from 'antd'
import { apiUrl } from '../../config/api'
import '../../config/httpInterceptor'

export default function AdminUsers() {
  const [data, setData] = React.useState([])
  const [loading, setLoading] = React.useState(false)
  const [editing, setEditing] = React.useState(null)
  const [form] = Form.useForm()

  async function load() {
    setLoading(true)
    try {
      const resp = await fetch(apiUrl('/api/admin/users'))
      if (!resp.ok) throw new Error('failed')
      const json = await resp.json()
      setData(Array.isArray(json) ? json : [])
    } catch (e) {
      console.error(e)
      message.error('فشل في تحميل المستخدمين')
    } finally {
      setLoading(false)
    }
  }

  React.useEffect(() => { load() }, [])

  function openEdit(record) {
    setEditing(record)
    form.setFieldsValue({
      phone: record.phone,
      name: record.name,
      deliveryLocationId: record.deliveryLocation?.id,
      fullAddress: record.fullAddress,
      isActive: record.isActive,
      deactivationReason: record.deactivationReason,
    })
  }

  async function saveEdit() {
    try {
      const values = await form.validateFields()
      const resp = await fetch(apiUrl(`/api/admin/users/${editing.id}`), {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(values),
      })
      if (!resp.ok) throw new Error('failed')
      message.success('تم حفظ التعديلات')
      setEditing(null)
      await load()
    } catch (e) {
      console.error(e)
      message.error('تعذر حفظ التعديلات')
    }
  }

  const columns = [
    { title: 'المعرف', dataIndex: 'id', key: 'id', width: 80 },
    { title: 'الهاتف', dataIndex: 'phone', key: 'phone' },
    { title: 'الاسم', dataIndex: 'name', key: 'name' },
    { title: 'منطقة التوصيل', key: 'deliveryLocation', render: (_, r) => r.deliveryLocation?.name || '—' },
    { title: 'العنوان الكامل', dataIndex: 'fullAddress', key: 'fullAddress' },
    { title: 'الحالة', dataIndex: 'isActive', key: 'isActive', render: (v) => v ? <Tag color="green">نشط</Tag> : <Tag color="red">معطل</Tag> },
    { title: 'سبب التعطيل', dataIndex: 'deactivationReason', key: 'deactivationReason' },
    { title: 'أنشئ في', dataIndex: 'createdAt', key: 'createdAt', width: 180 },
    { title: 'عدل في', dataIndex: 'updatedAt', key: 'updatedAt', width: 180 },
    {
      title: 'إجراءات', key: 'actions', fixed: 'right', width: 120,
      render: (_, record) => (
        <Space>
          <Button onClick={() => openEdit(record)}>تعديل</Button>
        </Space>
      ),
    },
  ]

  return (
    <div style={{ maxWidth: 1200, margin: '24px auto', padding: '0 12px' }}>
      <Card title="إدارة المستخدمين" extra={<Button onClick={load}>تحديث</Button>}>
        <Table
          rowKey="id"
          dataSource={data}
          columns={columns}
          loading={loading}
          pagination={{ pageSize: 20 }}
          scroll={{ x: 1100 }}
        />
      </Card>

      <Modal
        open={!!editing}
        title={`تعديل المستخدم #${editing?.id}`}
        onCancel={() => setEditing(null)}
        onOk={saveEdit}
        okText="حفظ"
        cancelText="إلغاء"
      >
        <Form form={form} layout="vertical">
          <Form.Item name="phone" label="الهاتف" rules={[{ required: true, message: 'الهاتف مطلوب' }]}>
            <Input placeholder="05XXXXXXXX" />
          </Form.Item>
          <Form.Item name="name" label="الاسم" rules={[{ required: true, message: 'الاسم مطلوب' }]}>
            <Input />
          </Form.Item>
          <Form.Item name="deliveryLocationId" label="معرف منطقة التوصيل (اختياري)">
            <Input placeholder="رقم أو اتركه فارغًا" />
          </Form.Item>
          <Form.Item name="fullAddress" label="العنوان الكامل">
            <Input />
          </Form.Item>
          <Form.Item name="isActive" label="الحالة">
            <Input placeholder="true أو false" />
          </Form.Item>
          <Form.Item name="deactivationReason" label="سبب التعطيل">
            <Input />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  )
}
